import { useSelector } from 'react-redux';
import { selectUserGroup } from '../../store/authReducer';
import { RoleTypes, hasRole } from '../components/Permission';
import { findPermissionRef, viewPermissionRefs } from '../components/UserGroupPermissions';

export const usePermissionCheck = (ref: string, includeOpAdmin = true): boolean => {
  const userGroup = useSelector(selectUserGroup);
  //see if the specific permission exists
  const permission = findPermissionRef(userGroup.permissions, ref);
  //check for an enhanced role
  if (includeOpAdmin) {
    const enhancedRole = findPermissionRef(userGroup.permissions, viewPermissionRefs.admin)
      ? 'Admin'
      : userGroup.role;
    //return true if permission exists or they have an enhanced role
    return permission !== undefined || hasRole(enhancedRole, RoleTypes.OperatorGroupAdmin);
  }
  //return true if permission exists (ignore OpAdmin roles)
  return permission !== undefined;
};
